import React, { useEffect, useState } from 'react'
import CustomizedModal from '../../../../ui/src/components/CustomizedModal/CustomizedModal'
import { Button, ICONS, SuccessModal } from '@ohif/ui'
import { servicesManager } from '../../App'
import { useSelector } from 'react-redux'
import { RootState } from '@custom/store/store';
import { useTheme } from "../../../../ui/src/contextProviders"
import { shareIcon } from "../../../../ui/assets/svgIcons/icon"
import { getReferPhysicianInfo, sharePatientReportLink } from '../../../../custom/Apis/apis'

const ShareStudies = ({ studiesToSend, setShareModal, shareModal, PhysicianDetails }) => {
  const { generateStudyLinkResponse } = useSelector((state: RootState) => state)
  const [shareLink, setShareLink] = useState('https://google.com')
  const [isCopied, setIsCopied] = useState(false)
  const [SuccessMessage, setSuccessMessage] = useState("")
  const [OpenSuccessModal, setOpenSuccessModal] = useState(false)

  useEffect(() => {
    if (generateStudyLinkResponse) {
      setShareLink(generateStudyLinkResponse?.result?.studyLink)
    }
  }, [generateStudyLinkResponse])

  const isDarkMode = useTheme();

  const handleShareClick = async () => {
    try {
      const payload = {
        "to": `whatsapp:+91${PhysicianDetails?.whatsappNo}`,
        "reportLink": shareLink
      }
      const response = await sharePatientReportLink(payload)
      if (response?.status === "SUCCESS") {
        setSuccessMessage(response?.msg)
        setOpenSuccessModal(true)
        setTimeout(() => {
          setOpenSuccessModal(false)
        }, 5000);
      }

    } catch (error) {
      console.log(error, "error")
    }
  }


  const RenderModalContent = () => {
    return <div className='flex items-center'>
      <input className='w-[80%]' placeholder='shareable link' value={shareLink} disabled />
      <Button onClick={copyText} className='h-11'>{isCopied ? 'Link copied' : 'Copy Link'}</Button>
      <div className='flex flex-row items-center gap-6 cursor-pointer mb-2' onClick={handleShareClick}>
        <img src={shareIcon} style={{
          ...isDarkMode?.isDarkMode ? { filter: 'invert(1)' } : null,
          width: '30px',
          height: '30px'
        }}
        />
      </div>
    </div>
  }

  const copyText = () => {
    navigator.clipboard.writeText(shareLink)
      .then(() => {
        console.log("Text copied to clipboard!")
        setIsCopied(true)
      })
      .catch(err => console.error("Failed to copy text:", err));
  }

  const closeModal = () => {
    setShareModal(false)
    setIsCopied(false)
  }
  return (
    <>
      <CustomizedModal
        closeButton={true}
        shouldCloseOnEsc={true}
        isOpen={shareModal}
        title={'Sharing Studies'}
        onClose={closeModal}
        shouldCloseOnOverlayClick={true}
        containerDimensions='44vw, auto'
        children={
          <RenderModalContent />
        }
      ></CustomizedModal>

      <SuccessModal
        isSuccessModalOpen={OpenSuccessModal}
        title={SuccessMessage}
        handleCloseModal={() => setOpenSuccessModal(false)}
      />
    </>

  )
}

export default ShareStudies
